module.exports = __webpack_public_path__ + "static/001_gan-e572cb4cbfaf643f6e1c9ca9c5f01921.jpg";